import { render } from "./EditableItemStudentClasses.vue?vue&type=template&id=a970e030&scoped=true&ts=true"
import script from "./EditableItemStudentClasses.vue?vue&type=script&lang=ts"
export * from "./EditableItemStudentClasses.vue?vue&type=script&lang=ts"

import "./EditableItemStudentClasses.vue?vue&type=style&index=0&id=a970e030&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a970e030"]])

export default __exports__